import React, { useState, useEffect } from 'react'
// import { useForm, Controller } from 'react-hook-form'
import {
  Panel,
  Row,
  Col,
  ControlLabel,
  Input,
  Form,
  SelectPicker,
  DatePicker,
  RadioGroup,
  Radio,
  CheckPicker,
} from 'rsuite'
import { isRequired, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import moment from 'moment'
import { DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'

export default function ProjectTrackingForm({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  handelPreview,
  clearValue,
  ...props
}) {
  // const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [schema, setSchema] = useState(_schema)
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [conditionBy, setConditionBy] = useState('')
  const [conditionVal, setConditionVal] = useState(0)
  const [startDates, setStartDates] = useState(null)
  const [endDates, setEndDates] = useState(null)
  const [fromBudgetYearOptions, setFromBudgetYearOptions] = useState(
    schema.budgetYearStartOption.options
  )
  const [toBudgetYearOptions, setToBudgetYearOptions] = useState(schema.budgetYearEndOption.options)

  useEffect(() => {
    if (!clearValue) {
      setStartDate(null)
      setEndDate(null)
      setConditionBy('')
      setConditionVal(0)
      setStartDates(null)
      setEndDates(null)

      // setValue(schema.searchType.name, '0')

      const indexOptionFromBudgetYear = schema.budgetYearEndOption.options.length - 1
      const indexOptionToBudgetYear = schema.budgetYearEndOption.options.length - 1

      setValue(
        schema.budgetYearStartOption.name,
        schema.budgetYearStartOption.options[indexOptionFromBudgetYear].value
      )
      setValue(
        schema.budgetYearEndOption.name,
        schema.budgetYearEndOption.options[indexOptionToBudgetYear].value
      )
    }
  }, [clearValue])

  const onChangeConditions = (conditionVal) => {
    // console.log('condition value ', conditionVal)
    // console.log('condition schema ', schema.conditions.options)
    if (conditionVal) {
      if (schema.conditions.options) {
        const condi = schema.conditions.options.find((condi) => condi.value === conditionVal)
        setConditionBy(condi.label)
        setConditionVal(conditionVal)
      }
    } else {
      setConditionBy('')
      setConditionVal(0)
    }
  }

  const handleChangeBudgetYear = (name, value) => {
    console.log(name, value)
    if (value) {
      let bgy = getValues(name)
      if (!bgy) {
        setValue(name, value)
        clearErrors(name)
      } else if (name == schema.budgetYearStartOption.name && bgy > value) {
        setValue(name, value)
      } else if (name == schema.budgetYearEndOption.name && bgy < value) {
        setValue(name, value)
      }

      if (name == schema.budgetYearStartOption.name) {
        setFromBudgetYearOptions(
          schema.budgetYearStartOption.options.filter((e) => e.value <= value)
        )
      }

      if (name == schema.budgetYearEndOption.name) {
        setToBudgetYearOptions(schema.budgetYearEndOption.options.filter((e) => e.value >= value))
      }
    } else {
      if (name == schema.budgetYearStartOption.name) {
        setFromBudgetYearOptions(schema.budgetYearStartOption.options)
      }

      if (name == schema.budgetYearEndOption.name) {
        setToBudgetYearOptions(schema.budgetYearEndOption.options)
      }
    }
  }

  return (
    <>
      <Form>
        <Row>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.searchType.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors.searchType} />
            <Controller
              name={schema.searchType.name}
              control={control}
              defaultValue={schema.searchType.value}
              // rule={register(isValidators(schema.searchType.validators))}
              render={(props) => {
                return (
                  <RadioGroup
                    name={schema.searchType.name}
                    inline
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {schema.searchType?.options &&
                      schema.searchType.options.map((item) => (
                        <Radio key={item.value} value={item.value}>
                          {item.label}
                        </Radio>
                      ))}
                  </RadioGroup>
                )
              }}
            />
          </Col>
        </Row>
        <Row>
          {schema?.projectStartDate && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {schema.projectStartDate.label}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.projectStartDate.name]} />
                <Controller
                  key={schema.projectStartDate.name}
                  name={schema.projectStartDate.name}
                  control={control}
                  defaultValue={
                    schema.projectStartDate.value
                      ? moment(schema.projectStartDate.value, DATE_PICKER_FORMAT).toDate()
                      : null
                  }
                  // rules={isValidators(schema.preApprovedProjectStartDate.validators)}
                  render={(props) => {
                    return (
                      <DatePicker
                        format="DD/MM/YYYY"
                        locale={LOCAL_DAY_TH}
                        block
                        value={startDates}
                        onChange={(value) => {
                          const date = moment(value).format(DATE_PICKER_FORMAT)
                          props.onChange(value)
                          setStartDates(value)
                        }}
                        disabledDate={(date) =>
                          endDates && moment(endDates).isBefore(date, new Date())
                        }
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}

          {schema?.projectEndDate && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {schema.projectEndDate.label}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.projectEndDate.name]} />
                <Controller
                  key={schema.projectEndDate.name}
                  name={schema.projectEndDate.name}
                  control={control}
                  defaultValue={
                    schema.projectEndDate.value
                      ? moment(schema.projectEndDate.value, DATE_PICKER_FORMAT).toDate()
                      : null
                  }
                  // rules={isValidators(schema.preApprovedProjectEndDate.validators)}
                  render={(props) => {
                    return (
                      <DatePicker
                        format="DD/MM/YYYY"
                        locale={LOCAL_DAY_TH}
                        block
                        value={endDates}
                        onChange={(value) => {
                          const date = moment(value).format(DATE_PICKER_FORMAT)
                          props.onChange(value)
                          setEndDates(value)
                        }}
                        disabledDate={(date) =>
                          startDates && moment(startDates).isAfter(date, new Date())
                        }
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}
        </Row>
        <Row>
          {schema?.budgetYearStartOption && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {requiredFiled(
                  schema.budgetYearStartOption.validators,
                  schema.budgetYearStartOption.label
                )}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.budgetYearStartOption.name]} />
                <Controller
                  name={schema.budgetYearStartOption.name}
                  control={control}
                  defaultValue={
                    fromBudgetYearOptions
                      ? Math.max(...fromBudgetYearOptions.map((item) => item.value))
                      : schema.budgetYearStartOption.value
                  }
                  // rules={isValidators(schema.fromBudgetYear.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={fromBudgetYearOptions}
                        // disabled={disabledValue.fromBudgetYear}
                        value={props.value}
                        block
                        placeholder={`เลือก${schema.budgetYearStartOption.label}`}
                        onChange={(value) => {
                          props.onChange(value)
                          handleChangeBudgetYear(schema.budgetYearEndOption.name, value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}

          {schema?.budgetYearEndOption && (
            <>
              <Col
                lg={4}
                md={4}
                sm={8}
                xs={8}
                style={{
                  marginTop: '5px',
                  padding: '8px',
                  textAlign: 'right',
                }}
              >
                {requiredFiled(
                  schema.budgetYearEndOption.validators,
                  schema.budgetYearEndOption.label
                )}
              </Col>
              <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
                <ErrorMessage error={errors[schema.budgetYearEndOption.name]} />
                <Controller
                  name={schema.budgetYearEndOption.name}
                  control={control}
                  defaultValue={
                    toBudgetYearOptions
                      ? Math.max(...toBudgetYearOptions.map((item) => item.value))
                      : schema.budgetYearEndOption.value
                  }
                  // rules={isValidators(schema.budgetYearEndOption.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={toBudgetYearOptions}
                        // disabled={disabledValue.toBudgetYear}
                        value={props.value}
                        block
                        placeholder={`เลือก${schema.budgetYearEndOption.label}`}
                        onChange={(value) => {
                          props.onChange(value)
                          handleChangeBudgetYear(schema.budgetYearStartOption.name, value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}
        </Row>
        <Row>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.startDate.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.startDate.name]} />
            <Controller
              key={schema.startDate.name}
              name={schema.startDate.name}
              control={control}
              defaultValue={
                schema.startDate.value
                  ? moment(schema.startDate.value, DATE_PICKER_FORMAT).toDate()
                  : null
              }
              // rules={isValidators(schema.startDate.validators)}
              render={(props) => {
                return (
                  <DatePicker
                    format="DD/MM/YYYY"
                    locale={LOCAL_DAY_TH}
                    block
                    value={startDate}
                    onChange={(value) => {
                      console.log('value', value)
                      const date = moment(value).format(DATE_PICKER_FORMAT)
                      console.log('date', date)
                      props.onChange(value)
                      setStartDate(value)
                    }}
                    disabledDate={(date) => endDate && moment(endDate).isBefore(date, new Date())}
                  />
                )
              }}
            />
          </Col>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.endDate.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.endDate.name]} />
            <Controller
              key={schema.endDate.name}
              name={schema.endDate.name}
              control={control}
              defaultValue={
                schema.endDate.value
                  ? moment(schema.endDate.value, DATE_PICKER_FORMAT).toDate()
                  : null
              }
              // rules={isValidators(schema.endDate.validators)}
              render={(props) => {
                return (
                  <DatePicker
                    format="DD/MM/YYYY"
                    locale={LOCAL_DAY_TH}
                    block
                    value={endDate}
                    onChange={(value) => {
                      const date = moment(value).format(DATE_PICKER_FORMAT)
                      props.onChange(value)
                      setEndDate(value)
                    }}
                    disabledDate={(date) =>
                      startDate && moment(startDate).isAfter(date, new Date())
                    }
                  />
                )
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.projectDepartment.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.projectDepartment.name]} />
            <Controller
              name={schema.projectDepartment.name}
              control={control}
              defaultValue={schema.projectDepartment.value}
              // rules={isValidators(schema.projectDepartment.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={schema.projectDepartment.options}
                    // disabled={disabledValue.constYear}
                    value={props.value}
                    block
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                      // onChangeMainProject(value)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.conditions.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.conditions.name]} />
            <Controller
              name={schema.conditions.name}
              control={control}
              defaultValue={schema.conditions.value}
              // rules={isValidators(schema.conditions.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={schema.conditions.options}
                    // disabled={disabledValue.constYear}
                    value={props.value}
                    block
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                      onChangeConditions(value)
                    }}
                  />
                )
              }}
            />
            {conditionVal != 0 && conditionBy != '' && (
              <Row style={{ marginTop: 10 }}>
                <Col>
                  <ErrorMessage error={errors[schema.textByConditions.name]} />
                  <ControlLabel>
                    {requiredFiled(
                      schema.textByConditions.validators,
                      schema.textByConditions.label + conditionBy
                    )}
                  </ControlLabel>
                  <Input
                    name={schema.textByConditions.name}
                    defaultValue={schema.textByConditions.value}
                    inputRef={register(isValidators(schema.textByConditions.validators))}
                    placeholder={'กรอก' + conditionBy}
                  />
                </Col>
              </Row>
            )}
          </Col>
        </Row>
        <Row>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.billPaymentStatus.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.billPaymentStatus.name]} />
            <Controller
              name={schema.billPaymentStatus.name}
              control={control}
              defaultValue={schema.billPaymentStatus.value}
              // rules={isValidators(schema.billPaymentStatus.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={schema.billPaymentStatus.options}
                    // disabled={disabledValue.constYear}
                    value={props.value}
                    block
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                      // onChangeMainProject(value)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.projectStatusOption.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.projectStatusOption.name]} />
            <Controller
              name={schema.projectStatusOption.name}
              control={control}
              defaultValue={schema.projectStatusOption.value}
              // rules={isValidators(schema.projectStatusOption.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={schema.projectStatusOption.options}
                    // disabled={disabledValue.constYear}
                    value={props.value}
                    block
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                      // onChangeMainProject(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>
        <Row>
          {/* <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.minReviewCycleOption.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.minReviewCycleOption.name]} />
            <Controller
              name={schema.minReviewCycleOption.name}
              control={control}
              defaultValue={schema.minReviewCycleOption.value}
              // rules={isValidators(schema.minReviewCycleOption.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    data={schema.minReviewCycleOption.options}
                    // disabled={disabledValue.constYear}
                    value={props.value}
                    block
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                      // onChangeMainProject(value)
                    }}
                  />
                )
              }}
            />
          </Col> */}
          <Col
            lg={4}
            md={4}
            sm={8}
            xs={8}
            style={{
              marginTop: '5px',
              padding: '8px',
              textAlign: 'right',
            }}
          >
            {schema.notiStatus.label}
          </Col>
          <Col lg={8} md={8} sm={16} xs={16} style={{ marginTop: '5px', padding: '8px' }}>
            <ErrorMessage error={errors[schema.notiStatus.name]} />
            <Controller
              name={schema.notiStatus.name}
              control={control}
              // rules={isValidators(schema.notiStatus.validators)}
              defaultValue={schema.notiStatus.defaultValue}
              render={(props) => {
                return (
                  <CheckPicker
                    sticky
                    data={schema.notiStatus.options}
                    defaultValue={schema.notiStatus.defaultValue}
                    value={props.value}
                    block
                    placeholder="เลือก"
                    onChange={(value) => {
                      props.onChange(value)
                      // console.log('x => ', value)
                      // onChangeMainProject(value)
                    }}
                  />
                )
              }}
            />
          </Col>
        </Row>
      </Form>
    </>
  )
}
